import './Signup.css';

const Signup = () => {
  const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSc4sjZhpeZCbqBtoBz4FsjgQ8GeQ_YAW0QXpK0buZW8HQiv-A/viewform?usp=dialog';

  return (
    <section id="signup" className="section section-alt signup">
      <div className="container">
        <div className="signup-content">
          <h2 className="signup-title">Join the Mailing List</h2>
          <p className="signup-description">
            Be the first to know when we launch direct rentals with exclusive perks, 
            locals' discounts, and special offers.
          </p>
          
          <a 
            href={googleFormUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn signup-btn"
          >
            Sign Up
          </a>

          <div className="signup-image-container">
            <img 
              src="/assets/images/signup-background.jpg" 
              alt="Mountain sunset" 
              className="signup-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Signup;
